<template>
  <el-submenu
    v-if="item.children && item.children.length > 0"
    :index="item.id"
  >
    <template slot="title">
      <i v-if="item.icon" :class="item.icon"></i>
      <span>{{ item.label }}</span>
    </template>
    <navigation-menu-item
      v-for="child in item.children"
      :key="child.id"
      :item="child"
      :level="level + 1"
      :collapsed="collapsed"
      :selected-id="selectedId"
    />
  </el-submenu>
  <el-menu-item
    v-else
    :index="item.id"
    :class="{ 'is-selected': item.id === selectedId }"
  >
    <i v-if="item.icon" :class="item.icon"></i>
    <span slot="title">{{ item.label }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: 'NavigationMenuItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    selectedId: {
      type: String,
      default: ''
    }
  },
  computed: {
    isParentSelected() {
      // 检查是否有子项被选中（用于收起状态下的父级高亮）
      if (this.collapsed && this.item.children) {
        return this.hasSelectedChild(this.item)
      }
      return false
    }
  },
  methods: {
    hasSelectedChild(item) {
      if (item.id === this.selectedId) return true
      if (item.children) {
        return item.children.some(child => this.hasSelectedChild(child))
      }
      return false
    }
  }
}
</script>



